import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { contentStyles, h2 } from '@helpers/typography';
import InformationCardStyles from '@stories/Components/Cards/InformationCard/InformationCard.styles';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import styled, { css } from 'styled-components';
const Container = styled(SectionWrapper) `
  background-color: var(--bgColour);

  &[data-site='ess'] {
    --bgColour: ${brand.ess.secondary.lightestGrey};
    --highlightColour: ${brand.global.red};
    --textColour: ${brand.ess.primary};
  }

  &[data-site='mep'] {
    --bgColour: ${brand.mep.secondary.lightestGrey};
    --highlightColour: ${brand.global.red};
    --textColour: ${brand.mep.primary};
  }

  ${SectionWrapperStyles.Inner} {
    ${baseGrid};
  }
`;
const contentSpans = css `
  grid-column: 1 / span 6;

  @media ${from(Device.Tablet)} {
    grid-column: 1 / span 4;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: 2 / span 3;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 3 / span 4;
  }
`;
const Title = styled.h2 `
  ${h2};

  color: var(--textColour);
  grid-column: 1 / span 6;

  > span {
    display: inline;
    color: var(--highlightColour);
  }

  @media ${from(Device.Tablet)} {
    grid-column: 1 / span 8;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: 2 / span 6;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 3 / span 8;
  }

  [data-site='mep'] & {
    ${fonts.museoSlab.medium};

    > span {
      ${fonts.daxWide.bold};
    }
  }
`;
const Description = styled.div `
  ${contentSpans};
  ${contentStyles};

  color: var(--textColour);
`;
const Cards = styled.div `
  ${baseGrid};

  grid-column: 1 / span 6;
  row-gap: var(--gutterWidth);
  margin: 40px 0 0;

  @media ${from(Device.Tablet)} {
    grid-column: 1 / span 8;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 1 / span 12;
  }

  ${InformationCardStyles.Outer} {
    ${contentSpans};

    &[data-site='ess'] {
      --bgColour: ${brand.ess.secondary.lightestGrey};
    }

    &:nth-child(even) {
      @media ${from(Device.Tablet)} {
        grid-column: 5 / span 4;
      }

      @media ${from(Device.TabletLarge)} {
        grid-column: 5 / span 3;
      }

      @media ${from(Device.Desktop)} {
        grid-column: 7 / span 4;
      }
    }
  }
`;
const InformationCardsStyles = {
    Cards,
    Container,
    Description,
    Title,
};
export default InformationCardsStyles;
